module.exports = __webpack_public_path__ + "media/images/phone-d75ddbcee59772550e89023a10ddac19.png";